import { render, staticRenderFns } from "./supplement-manage-handled.vue?vue&type=template&id=36f5beef&scoped=true"
import script from "./supplement-manage-handled.vue?vue&type=script&lang=ts"
export * from "./supplement-manage-handled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5beef",
  null
  
)

export default component.exports